import { render, staticRenderFns } from "./FraisAttachments.vue?vue&type=template&id=2f6d8e40"
import script from "./FraisAttachments.vue?vue&type=script&lang=ts"
export * from "./FraisAttachments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports